import { render, staticRenderFns } from "./tikuan.vue?vue&type=template&id=33bf2fb2"
import script from "./tikuan.vue?vue&type=script&lang=js"
export * from "./tikuan.vue?vue&type=script&lang=js"
import style0 from "./tikuan.vue?vue&type=style&index=0&id=33bf2fb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports